// Legacy balance bands. Presentation uses visual-ages.ts, aligned to ageName().
// Keep these bands stable for saves and any gameplay consumers.

// age -> era index (clamped). Roughly two ages per era across the early game;
// the final era stretches into the star age.
export const AGE_ERA = [0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 4, 4, 4] as const;

/** Number of distinct eras. */
export const ERA_COUNT = 5;

/** Era index for a given age, clamped to the valid range. */
export function eraIndex(age: number): number {
  return AGE_ERA[Math.max(0, Math.min(age, AGE_ERA.length - 1))];
}
